import React from "react";
import Link from "next/link";
import { Grid } from "@mui/material";
import styles from "./hero.module.scss";

export const CareerHero = () => {
  return (
    <section className={styles.wrapper}>
      <div className="container">
        <div className={styles.hero_wrapper}>
          <h1 className={styles.heading}>
            Are You the Right Person For the Job?{" "}
            <span className="mark"> Join Us Today!</span>
          </h1>
          <p className={styles.sub_text}>
            People are at the heart of everything we do. And we’re constantly on
            the lookout for the right people to help UniSearch do what it does
            best - create meaningful connections in higher education. Do you
            have what it takes? Apply today to be a part of our team!
          </p>
          <Link legacyBehavior href="#jobs">
            <a
              className="btn btn-secondary btn-bg btn-secondary-box-shadow"
              style={{ display: "inline-block" }}
            >
              See Available Jobs
            </a>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CareerHero;
